import {process} from './actions'
import Container from './container'
import Reducer from './reducer'

export {
  process,
  Reducer
}

export default Container


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/index.js